"use client";

import React from "react";
import { Scissors, Utensils, Wrench, Stethoscope, Calculator, Dumbbell } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const industries = [{
  name: "Event Planners",
  icon: Scissors
}, {
  name: "Festivals",
  icon: Utensils
}, {
  name: "Construction Sites",
  icon: Wrench
}, {
  name: "Emergency Response",
  icon: Stethoscope
}, {
  name: "Municipalities",
  icon: Calculator
}, {
  name: "Venues & Stadiums",
  icon: Dumbbell
}];
export default function IndustriesWeHelp() {
  return <section data-section-id="224511" id="sectors-we-empower" className="bg-background py-24 sm:py-32 overflow-hidden text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground mb-6 tracking-tight border-b border-primary/20 pb-6">
            Sectors We Empower
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-sans">
            Elite sanitation logistics for enterprise-scale venues and national operations.
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-6">
              {industries.map((industry, i) => {
              const Icon = industry.icon;
              return <CarouselItem key={i} data-index={i} className="pl-4 md:pl-6 basis-1/2 md:basis-1/3 lg:basis-1/4 xl:basis-1/5">
                    <div className="group flex flex-col items-center justify-center p-8 h-full rounded-2xl border border-border/40 hover:border-primary/30 hover:bg-card hover:shadow-xl transition-all duration-500 ease-out cursor-default backdrop-blur-sm">
                      <div className="mb-6 p-5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 group-hover:bg-primary/10 transition-colors duration-500 ease-out relative overflow-hidden">
                        {}
                        <div className="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-full blur-xl"></div>
                        <Icon className="w-10 h-10 text-muted-foreground/70 grayscale group-hover:grayscale-0 group-hover:text-primary relative z-10 transition-all duration-500 ease-out" />
                      </div>
                      <h3 className="font-default font-semibold text-foreground text-center text-lg transition-colors duration-300 group-hover:text-primary">
                        {industry.name}
                      </h3>
                    </div>
                  </CarouselItem>;
            })}
            </CarouselContent>
            
            {}
            <div className="flex items-center justify-center gap-4 mt-12">
              <CarouselPrevious className="static translate-y-0 translate-x-0 size-12 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors duration-300 shadow-sm" />
              <CarouselNext className="static translate-y-0 translate-x-0 size-12 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors duration-300 shadow-sm" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}